import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class UsuarioService {

    getMe(data) {
        return axiosInstance.get(`${config.api.version}/auth/${data}/me`)
    }

    listAllUsers(data) {
        return axiosInstance.get(`${config.api.version}/user/${data}/get`)
    }

    getUser(data, id) {
        return axiosInstance.get(`${config.api.version}/user/${data}/get/${id}`)
    }

    getUserFilter(data, search) {
        return axiosInstance.get(`${config.api.version}/user/${data}/get?${search}`)
    }

    postUser(data, user) {
        return axiosInstance.post(`${config.api.version}/user/${data}/`, user)
    }

    putUser(data, user, id) {
        return axiosInstance.put(`${config.api.version}/user/${data}/${id}`, user)
    }

    deleteUser(data, id) {
        return axiosInstance.delete(`${config.api.version}/user/${data}/${id}/soft`)
    }

    activeUser(data, id, status) {
        return axiosInstance.put(`${config.api.version}/user/${data}/active/${id}/${status}`)
    }

    changeRoleUser(data, user, id) {
        return axiosInstance.put(`${config.api.version}/user/${data}/role/${id}`, user)
    }

}
